"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SidebarMenuItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _clsx = _interopRequireDefault(require("clsx"));

var _reactI18next = require("react-i18next");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    item: {
      display: 'flex',
      paddingTop: 0,
      paddingBottom: 0
    },
    button: {
      color: theme.palette.primary.contrastText,
      padding: '10px 8px',
      justifyContent: 'flex-start',
      textTransform: 'none',
      letterSpacing: 0,
      width: '100%',
      fontWeight: theme.typography.fontWeightMedium
    },
    icon: {
      color: theme.palette.primary.contrastText,
      width: 24,
      height: 24,
      display: 'flex',
      alignItems: 'center',
      marginRight: theme.spacing(1)
    },
    active: {
      color: theme.palette.secondary.main,
      fontWeight: theme.typography.fontWeightMedium,
      '& $icon': {
        color: theme.palette.secondary.main
      }
    }
  };
});

var SidebarMenuItem = function SidebarMenuItem(_ref) {
  var title = _ref.title,
      icon = _ref.icon,
      active = _ref.active;
  var classes = useStyles();

  var _useTranslation = (0, _reactI18next.useTranslation)('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/_react.default.createElement(_core.ListItem, {
    className: classes.item,
    disableGutters: true
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: active ? (0, _clsx.default)(classes.button, classes.active) : classes.button
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.icon
  }, icon), t("routes.".concat(title))));
};

exports.SidebarMenuItem = SidebarMenuItem;
var _default = SidebarMenuItem;
exports.default = _default;